"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var shared_1 = require("mad-utils/lib/shared");
var moment_1 = __importDefault(require("moment"));
var kotlin_map_factory_1 = require("../util/kotlin-map-factory");
var date_time_all_1 = require("../date/date-time-all");
var date_time_all_2 = require("../date/date-time-all");
var javelin_exports_1 = require("../javelin-exports");
/********************************* EXPORT DATA WITH TYPES APPLIED *********************************/
exports.Record = javelin_exports_1.javelin.data.model.user.Record;
exports.Record_init_db = javelin_exports_1.javelin.data.model.user.Record_init_db;
exports.Record_init_client = javelin_exports_1.javelin.data.model.user.Record_init_client;
/**
 * Attach both constructors to each constructor's associated prototype object
 * Required because JS doesn't have constructor overloading
 */
Object.keys(exports.Record.prototype).forEach(function (key) {
    Reflect.defineProperty(exports.Record_init_db.prototype, key, {
        enumerable: true,
        configurable: false,
        writable: true,
        value: exports.Record.prototype[key],
    });
    Reflect.defineProperty(exports.Record_init_client.prototype, key, {
        enumerable: true,
        configurable: false,
        writable: true,
        value: exports.Record.prototype[key],
    });
});
shared_1.defineProperty(javelin_exports_1.javelin.data.model.user, "Record_init_db", exports.Record_init_db);
shared_1.defineProperty(javelin_exports_1.javelin.data.model.user, "Record_init_client", exports.Record_init_client);
/********************************** ATTACH STATIC FACTORY METHOD **********************************/
// Note: We *could* try to move the below static factory into Kotlin, but it's
// fairly complex & uses some JS/implementation-specific features/concessions:
// e.g. Array detection only works consistently because we overloaded the prototype
// (there's no way for the Kotlin compiler to know this), which is required for
// cases where MobX data gets passed to this function (Getting Kotlin to handle
// MobX-augmented data is likely not possible without gargantuan effort)
/**
 * Powerful static factory method for building Record instances from data objects
 *
 * Required because JS doesn't have constructor overloading, determining which
 * 'new' call to make at what location in the client is confusing (it's better
 * to have a single record factory method), and having a single method we can
 * throw all Record-constructable data at makes this rehydration easy (no
 * in-app detection required, etc)
 *
 * Used e.g. by JavelinJson to easily rehydrate Record objects from JSON data,
 * for testing & building Record mocks, etc
 *
 * @param {RecordData} data Data object to hydrate the record with
 * @return {RecordInstance} instantiated & hydrated Record object
 */
var newFromDict = function Record_init_db_newFromDict(data) {
    // Build partial record with lateinit props taken care of in advance
    var partialRecord = Object.create(this.prototype);
    // Build birthdate property
    partialRecord.birthdate = new date_time_all_1.LocalDate(moment_1.default(data.birthdate));
    // Build consents property
    shared_1.defineMutableProp(partialRecord, "consents", data.consents);
    partialRecord.consents = data.consents;
    // ******** If it's a Record returned from storage ********
    if (data.recordId) {
        // Hydrate doses
        var cleanDoses_1 = [];
        if (data.doses && Array.isArray(data.doses) && data.doses.length > 0) {
            data.doses.forEach(function (dose) {
                cleanDoses_1.push(new javelin_exports_1.Dose_init_db(dose.doseId, dose.lastUpdated ? new date_time_all_2.ZonedDateTime(moment_1.default(dose.lastUpdated)) : null, dose.recordId, dose.conceptId, dose.generatorId, dose.pageId, dose.scheduleId, dose.date ? new date_time_all_1.LocalDate(moment_1.default(dose.date)) : null, dose.isReceived, dose.gtin, dose.lotNumber, dose.expiry ? new date_time_all_1.LocalDate(moment_1.default(dose.expiry)) : null, dose.comments, Object.create(javelin_exports_1.Dose.prototype)));
            });
        }
        // Hydrate integrations
        // TODO Handle other integration types
        var cleanIntegrations_1 = [];
        if (data.integrations && Array.isArray(data.integrations) && data.integrations.length > 0) {
            data.integrations.forEach(function (integration) {
                var phuIntegration = integration;
                cleanIntegrations_1.push(new javelin_exports_1.PHUIntegration_init_db(phuIntegration.integrationId, phuIntegration.type, phuIntegration.recordId, phuIntegration.consents, phuIntegration.phuId, phuIntegration.guardianFirstName, phuIntegration.guardianLastName, phuIntegration.ohip, phuIntegration.phoneNumber, phuIntegration.address1, phuIntegration.address2, phuIntegration.postalCode));
            });
        }
        // Hydrate actual Record object
        var recRet = new exports.Record_init_db(data.recordId, data.lastUpdated ? new date_time_all_2.ZonedDateTime(moment_1.default(data.lastUpdated)) : null, data.lastSyncTimestamp ? new date_time_all_2.ZonedDateTime(moment_1.default(data.lastSyncTimestamp)) : null, data.firstName, data.lastName, data.gender, data.birthdate ? new date_time_all_1.LocalDate(moment_1.default(data.birthdate)) : null, data.region, data.scheduleId, data.relationship, data.doctor, data.cityId, data.notes, cleanDoses_1, data.consents, cleanIntegrations_1, data.ignoredGenerators, kotlin_map_factory_1.dirtyKotlinMap(data.doseComments), data.hideIgnoredPages, partialRecord);
        if (recRet.doseComments && recRet.doseComments.getObject) {
            recRet.doseComments = kotlin_map_factory_1.dirtyKotlinMap(recRet.doseComments.getObject());
        }
        return recRet;
    }
    else if (data.firstName || data.lastName) {
        // ******** If it's a Record created in the client ********
        var newRec = new exports.Record_init_client(partialRecord);
        newRec.saveRecord(data.firstName, data.lastName, data.gender, data.birthdate ? new date_time_all_2.ZonedDateTime(moment_1.default(data.birthdate)) : new date_time_all_2.ZonedDateTime(), data.region, data.scheduleId, data.relationship, data.doctor, data.cityId, data.notes, data.consentDate ? new date_time_all_2.ZonedDateTime(moment_1.default(data.consentDate)) : new date_time_all_2.ZonedDateTime(), true);
        return newRec;
    }
};
/********************************** ATTACH ADDITIONAL PROPERTIES **********************************/
/**
 * Local convenience helper to attach more props to record constructor or prototype
 * Required because JS lacks constructor overloading & thus requires a full
 * separate object for each constructor - this lets us add props to all 3
 * "versions" of the Record "class" (one per constructor) at once
 */
var setAll = function setAll(fnName, fn, proto) {
    function setOnConstructor(recordConstructorKey) {
        var user = javelin_exports_1.javelin.data.model.user;
        var recProto = proto
            ? user[recordConstructorKey].prototype
            : user[recordConstructorKey];
        recProto[fnName] = fn;
    }
    setOnConstructor("Record");
    setOnConstructor("Record_init_db");
    setOnConstructor("Record_init_client");
};
setAll("newFromDict", newFromDict);
// For debugging & testing
setAll("JVLN_CLASS_NAME", "Record", true);
//# sourceMappingURL=record.js.map